// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainPage_mainContainer__DYspd","titleContainer":"MainPage_titleContainer__23KY4","pokeballBackground":"MainPage_pokeballBackground__hwQLy"};